export default __webpack_public_path__ + "static/media/node-js.6d046992.png";